import useGenericEntityStore from '@/layouts/entity/entityStoreModule'

const { storeModule } = useGenericEntityStore('congress-registrations')
export default storeModule
